import styled from '@emotion/styled';
import React from 'react';

import { ImageButton } from '../../common/ImageButton';
import colorWheel from '../images/color/color-wheel.png';
import temperatureWheel from '../images/color/temperature-wheel.png';

import { su } from '../../../theme/functions/su';

export function ModeButton({ mode, ...rest }) {
  return <ModeButtonBase {...rest} url={getImage(mode)} />;
}

function getImage(mode) {
  switch (mode) {
    case 'color':
      return colorWheel;
    case 'temperature':
      return temperatureWheel;
    default:
      return colorWheel;
  }
}

const ModeButtonBase = styled(ImageButton)`
  position: relative;

  &:first-of-type:not(:only-child) {
    margin-inline-end: ${su(2)};
  }
`;
